import { FC } from 'react';
// @ts-ignore
import { StarSvg } from '@/assets/Icons';
import dict from '@/dictionaries/fa.json';
// @ts-ignore
import { cn } from '@/helpers/cn';
import { SearchResultCard } from '@/app/search/models/results';
import StatefulLink from '@/components/StatefulLink';
import { dynamicClientRouteMaker } from '@/helpers/routes/dynamicClientRouteMaker';
import useSourcePageTracker from '@/context/sourcePageTracker/useSourcePageTracker';

type SearchResultAudioCardPropsType = {
    className?: string;
    cardData: SearchResultCard;
};

const SearchResultAudioCard: FC<SearchResultAudioCardPropsType> = ({
                                                                       className,
                                                                       cardData
                                                                   }) => {

    const { sourcePageData } = useSourcePageTracker();

    return (
        <StatefulLink
            href={dynamicClientRouteMaker({
                id: cardData.related_link?.obj_id,
                type: cardData.data_type,
                urlAlias: cardData.related_link?.url_alias,
                multimediaType: cardData.multi_media_type
            })}
            state={sourcePageData}
            className={cn('flex w-full gap-2', className)}>
            <img
                className="w-[31%] shrink-0 aspect-square object-cover rounded-xl"
                src={cardData.posters.vertical_poster}
                alt={cardData.title}
            />
            <div className="flex flex-col">
                <h4 className="font-semibold text-base mb-2">{cardData.title}</h4>
                <p className="text-neutral-800 text-sm">{cardData.description}</p>
                <div className="flex items-center mt-auto text-neutral-700 text-sm">
                    <StarSvg className="w-4 h-4 me-1" />
                    <span className="me-1 font-semibold">{cardData.rate_average}</span>
                    <span>{`(${cardData.rate_count} ${dict.comment})`}</span>
                    <span className="rounded-full w-1 h-1 bg-[#A3A3A3] mx-2"></span>
                    <span className="font-semibold">{`${cardData.duration_minutes} ${dict.minute}`}</span>
                </div>
                {/*<p className="text-neutral-600 mt-1">*/}
                {/*    {`${dateCreated} ${dict.search.daysAgoAdded}`}*/}
                {/*</p>*/}
            </div>
        </StatefulLink>
    );
};

export default SearchResultAudioCard;